// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.gamic",
    name: "Gamic",
    homepage: "https://gamic.app",
    image_id: "cf404c15-391c-4144-1ec0-17f1b119ed00",
    app: {
        browser: "https://gamic.app/",
        ios: "https://apps.apple.com/us/app/gamic-spaces-chat-connect/id1673683070",
        android: "https://play.google.com/store/apps/details?id=app.gamic.guild.gamic_guild_mobile",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "gamic://",
        universal: "https://www.gamic.app/wc",
    },
    desktop: {
        native: "gamic://",
        universal: null,
    },
};
//# sourceMappingURL=index.js.map